export const domain = 'https://www.keliones.piligrimas.lt/';
export const instagramId = 6259642427;
